/* eslint-disable react/jsx-props-no-spreading */
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import MessagePlayer from './MessagePlayer';

const MessageCard = ({ edit, checked, mode, type, value, onChange, item }) => {
  return (
    <Card key={item.id}>
      <CardContent>
        {edit && (
          <Checkbox
            color="secondary"
            checked={checked}
            onChange={onChange}
            sx={{ px: 0 }}
          />
        )}
        <Stack sx={{ px: 1 }}>
          <Typography variant="subtitle2">전달 방식</Typography>
          <Typography sx={{ mt: 1, mb: 2 }} color="text.secondary">
            {mode === 'realTime' ? '실시간' : '인체감지'}
          </Typography>
          <Typography variant="subtitle2">보낼 로봇</Typography>
          <Stack direction="row" sx={{ mt: 1, mb: 2 }}>
            {item.map((el) => (
              <Chip key={el.id} label={el.serial} color="secondary" />
            ))}
          </Stack>
          <Typography variant="subtitle2">메시지 내용</Typography>
          {type === 'text' && (
            <TextField
              id="outlined-value-static"
              name="value"
              placeholder="내용을 입력하세요"
              rows={3}
              value={value}
              margin="dense"
              fullWidth
              multiline
              disabled
            />
          )}
          {type === 'voice' && (
            <Box sx={{ m: 1 }}>
              <MessagePlayer value={value} />
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MessageCard;
